import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { 
  Home, 
  Users,
  CheckCircle,
  ExternalLink
} from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const HouseholdDetailsCard = ({ caseId, caseData, participant, onUpdate }) => {
  const navigate = useNavigate();
  
  // Determine if this is a Food Pantry case
  const isFoodPantryCase = caseData?.program_name?.toLowerCase().includes('food pantry');

  // Get household size from participant's income_info (auto-populated from profile)
  const householdSize = participant?.income_info?.household_size || 1;

  // Only show for Food Pantry cases
  if (!isFoodPantryCase) {
    return null;
  }

  return (
    <Card className="card-shadow border-green-200 bg-gradient-to-br from-green-50 to-white">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg flex items-center gap-2 text-green-800">
            <Home className="w-5 h-5" />
            Household Details
          </CardTitle>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => navigate(`/participants/${caseData?.participant_id}`)}
            className="border-green-300 hover:bg-green-100"
            data-testid="view-profile-btn"
          >
            <ExternalLink className="w-4 h-4 mr-1" />
            View Profile
          </Button>
        </div>
        <CardDescription>Auto-populated from participant profile</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="space-y-1">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Users className="w-4 h-4" />
              Number of Household Members
            </div>
            <div className="flex items-center gap-2">
              <p className="font-medium text-lg">{householdSize}</p>
              <CheckCircle className="w-4 h-4 text-green-600" />
            </div>
            <p className="text-xs text-muted-foreground">
              From Income Information in Profile Details
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default HouseholdDetailsCard;
